export { default } from './MobileCatalogCardSlider';
